// Module
var code = "<h2 id=\"in-repaymentget-temporary-payment-relief\">In Repayment&mdash;Get Temporary Payment Relief</h2> <p>If you&#39;re facing financial hardship, you might qualify for deferment or forbearance, which temporarily suspends payments. </p> ";
// Exports
export default code;